import loding from '../image/loding.png'
import '../css/splash.css'

const Splash = () => {
  return (
    <div className='splash'>
      <img src={loding} className="App-logo" alt="logo" />
    </div>
  )
}

export default Splash;